import React from 'react';
import {
    BooleanField,
    Datagrid,
    DateField,
    EmailField,
    FunctionField,
    List,
    ReferenceField,
    TextField,
} from 'react-admin';
import { DoctorReferenceField, PatientReferenceField } from "../../misc/customFields";

export const TransferList = props => {
    return (
        <div>
            <List {...props} >
                <Datagrid>
                    <TextField
                        source="patient.id"
                        label="Patient ID"
                    />
                    <PatientReferenceField
                        label="Patient"
                        source="patient.id"
                        sortBy="patient"
                    />
                    <EmailField
                        source="patient.email"
                        label="Patient Email"
                    />
                    <DoctorReferenceField
                        label="Old Clinician Owner"
                        source="old_owner"
                    />
                    <DoctorReferenceField
                        label="New Clinician Owner"
                        source="new_owner"
                    />
                    <BooleanField source="include_notes" label="Transfered Notes" />
                    <DateField
                        label="Date of Transfer"
                        source="start_date"
                        showTime
                    />
                </Datagrid>
            </List>
        </div>
    )
}
